module.exports = __webpack_public_path__ + "img/940-adb38b.png";